import { computed, makeObservable } from "mobx";

class Counters {
  profile;

  rootStore;

  constructor(profile, rootStore) {
    this.rootStore = rootStore;
    this.profile = profile;

    makeObservable(this, {
      docs: computed,
      docsInbox: computed,
      docsAwaitingDecision: computed,
      docsYourCounterparties: computed,
      docsYouInvited: computed,
      docsYouAreInvited: computed,
      docsClosing: computed,
      docsCountersList: computed,
      burger: computed,
      ordersToYou: computed,
      yourOrders: computed,
      orders: computed,
      hasZeroRealTrucks: computed,
      autopark: computed,
      trucksActions: computed,
      yourTrucks: computed,
      boards: computed,
      haveBoards: computed,
      boardsParticipating: computed,
      loadsMain: computed,
      tenders: computed,
      tendersEvents: computed,
      carriers: computed,
      cargoOwners: computed,
      countersList: computed,
      shouldRedirectBoardsToLoads: computed,
    });
  }

  get countersList() {
    return this.profile.user && this.profile.user.counters
      ? this.profile.user.counters
      : {};
  }

  get docsCountersList() {
    return this.profile.docsCounters || {};
  }

  get burger() {
    return (
      this.carriers +
        this.cargoOwners +
        this.docs +
        (this.rootStore.chat.chatUnreadCount
          ? parseInt(this.rootStore.chat.chatUnreadCount, 10)
          : 0) || 0
    );
  }

  get ordersToYou() {
    return this.countersList.autopark_actions;
  }

  get yourOrders() {
    return this.countersList.loads_actions;
  }

  get orders() {
    return this.ordersToYou + this.yourOrders;
  }

  get hasZeroRealTrucks() {
    const licenses = this.profile.licenses;

    if (!licenses) {
      return false;
    }

    const hasLicenseRealTruck = licenses.checkForLicense(559);

    return hasLicenseRealTruck && !this.countersList.real_trucks_count;
  }

  get autopark() {
    return this.hasZeroRealTrucks ? 1 : 0;
  }

  get trucksActions() {
    return this.countersList.trucks_actions;
  }

  get yourTrucks() {
    return this.countersList.trucks_actions || this.countersList.trucks_main;
  }

  get isBoardsActive() {
    return (
      this.countersList.boards_applicants +
        this.countersList.boards_invitations >
      0
    );
  }

  get boards() {
    return this.isBoardsActive
      ? this.countersList.boards_applicants +
          this.countersList.boards_invitations
      : this.countersList.boards_applications;
  }

  get haveBoards() {
    return this.countersList.boards_main;
  }

  get boardsParticipating() {
    return this.countersList.boards_participating;
  }

  get shouldRedirectBoardsToLoads() {
    return (
      this.countersList.boards_main ||
      this.countersList.boards_participating ||
      this.countersList.boards_applications
    );
  }

  get loadsMain() {
    return this.countersList.loads_main;
  }

  get tenders() {
    return (
      this.countersList.tenders_events || this.countersList.tenders_count || 0
    );
  }

  get tendersEvents() {
    return this.countersList.tenders_events;
  }

  get cargoOwners() {
    return (
      (this.tendersEvents ? this.tenders : 0) +
      this.yourOrders +
      (this.isBoardsActive ? this.boards : 0)
    );
  }

  get carriers() {
    return (
      (this.trucksActions ? this.yourTrucks : 0) +
        this.ordersToYou +
        (this.isBoardsActive ? this.boards : 0) +
        this.autopark || 0
    );
  }

  // Входящие
  get docsInbox() {
    return this.docsCountersList.incoming_unread;
  }

  // Ожидают решения
  get docsAwaitingDecision() {
    return this.docsCountersList.waiting;
  }

  // Ваши контрагенты
  get docsYourCounterparties() {
    return this.docsCountersList.roaming_counters
      ? this.docsCountersList.roaming_counters.read.established
      : 0;
  }

  // Вы приглашали
  get docsYouInvited() {
    return this.docsCountersList.roaming_counters
      ? this.docsCountersList.roaming_counters.read.outgoing
      : 0;
  }

  // Вас приглашают
  get docsYouAreInvited() {
    return this.docsCountersList.roaming_counters
      ? this.docsCountersList.roaming_counters.unread.incoming
      : 0;
  }

  // Закрывающие от ATI.SU
  get docsClosing() {
    return this.docsCountersList.closing_from_ati;
  }

  get docs() {
    return this.docsYouAreInvited + this.docsInbox;
  }
}

export default Counters;
